import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';
import { CreateProblemEntity, ProblemEntity, ProblemEntityListResponse, ProblemEntityQueryParams } from '@frontend/problem/types';

export class ProblemEntityClient extends APIClient {
    public static readonly endpoint = '/problem-api/v1';
    public static async fetchProblemEntities(queryParams?: ApiQueryParams<DefaultQueryParams & ProblemEntityQueryParams>): Promise<ProblemEntityListResponse> {
        return await this.apiPaginated<ProblemEntityListResponse, DefaultQueryParams & ProblemEntityQueryParams>(
            `${this.endpoint}/problem-entities`,
            queryParams
        );
    }

    public static async resolveProblemEntities(ids: string[], field: string = 'id'): Promise<ProblemEntityListResponse> {
        return this.resolve<ProblemEntityListResponse>(`${this.endpoint}/problem-entities`, ids, field);
    }

    public static async deleteProblemEntities(ids: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/problem-entities-delete`, { ids: ids });
        return await this.handleVoidResponse(response);
    }

    public static async postProblemEntity(accountId: string, problemId: string, body: CreateProblemEntity): Promise<ProblemEntity> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/problems/${problemId}/entities`, body);
        return await this.handleResponse<ProblemEntity>(response);
    }

    public static async fetchProblemEntity(accountId: string, problemId: string, problemEntityId: string): Promise<ProblemEntity> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/problems/${problemId}/entities/${problemEntityId}`);
        return await this.handleResponse<ProblemEntity>(response);
    }

    public static async deleteProblemEntity(accountId: string, problemId: string, problemEntityId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/problems/${problemId}/entities/${problemEntityId}`);
        return await this.handleVoidResponse(response);
    }
}
